import { render, staticRenderFns } from "./RestaurantContractsDialog.vue?vue&type=template&id=6bb0e8b7&scoped=true"
import script from "./RestaurantContractsDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantContractsDialog.vue?vue&type=script&lang=js"
import style0 from "./RestaurantContractsDialog.vue?vue&type=style&index=0&id=6bb0e8b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb0e8b7",
  null
  
)

export default component.exports